/**
 * HTTP Configuration constants
 */
export const HTTP_CONFIG = {
    // BASE_URL: 'http://localhost:8081/api',
    DEFAULT_HEADERS: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    },
    DEFAULT_TIMEOUT: 120000 // 120 seconds
};

/**
 * HTTP Status Codes
 */
export const HttpStatus = {
    OK: 200,
    CREATED: 201,
    NO_CONTENT: 204,
    BAD_REQUEST: 400,
    UNAUTHORIZED: 401,
    FORBIDDEN: 403,
    NOT_FOUND: 404,
    TIMEOUT: 408,
    INTERNAL_SERVER_ERROR: 500,
    SERVICE_UNAVAILABLE: 503,
};